module.exports = __webpack_public_path__ + "img/185-855fdd.png";